import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

import { CeStructureTreeNode } from '../models/ce-structure-tree';

@Pipe({
  name: 'getCeStructureTitle'
})
export class GetCeStructureTitlePipe implements PipeTransform {

    constructor(protected sanitizer: DomSanitizer) {}

    /* Build the structure title from data */
    transform(structure: CeStructureTreeNode, suffix: string = ''): SafeHtml {
        let title = '';

        if (structure) {
            title += structure.name;
            if (structure.completion) {
                if (structure.completion !== 'closed') {
                    title += ' <em>[' + structure.completion + ']</em>';
                }
                if (structure.completion === 'provisional') {
                    title = '<strong>' + title + '</strong>';
                }
            }
        }

        if (suffix) {
            title += suffix;
        }

        return this.sanitizer.bypassSecurityTrustHtml(title);
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/get-ce-structure-title.pipe.ts